import React, { useEffect, useState } from "react";
import Button from "../../shared/Button";
import { useSubjectArea } from "../../../hooks/useSubjectArea";
import { Spinner } from "reactstrap";
import swal from "sweetalert";
import PermissionButton from "../../shared/PermissionButton";
import { checkRolePermissions } from "../../../../../utils/Constants";
import AccessDenied from "../../shared/AccessDenied";

const CreateSubjectArea = ({ name: widgetName }) => {
  const { createSubjectArea, loading } = useSubjectArea();
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [permission, setPermission] = useState({
    permissionInsertSubjectArea: false,
    permissionEditSubjectArea: false,
    permissionDeleteSubjectArea: false,
  });

  const handleSubjectAreaSubmit = async (e) => {
    e.preventDefault();

    if (!name.trim()) {
      swal("Oops", "Name is required");
      return;
    }

    const data = {
      name: name?.trim(),
      description: description?.trim(),
    };

    try {
      await createSubjectArea(data);

      setName("");
      setDescription("");
    } catch (err) {
      console.error("Create failed:", err);
    }
  };

  const checkPermissions = () => {
    setPermission({
      permissionInsertSubjectArea: checkRolePermissions(
        "insert-subject-area",
        "activity",
        widgetName,
      ),
    });
  };

  useEffect(() => {
    checkPermissions();
  }, []);

  return (
    <>
      <div className="arr-content">
        <div className="arr-heading">
          <h1>Create Subject Area</h1>
          <div className="arr-btns-group">
            <PermissionButton
              widgetName={widgetName}
              moduleName={"Subjects Setup"}
              activityName={"insert-subject-area"}
              header={"Create Subject Area"}
            />
          </div>
        </div>
        {permission.permissionInsertSubjectArea ? (
          <div className="arr-form-center">
            <form
              onSubmit={handleSubjectAreaSubmit}
              className="arr-form arr-subject-setup-form"
              style={{ width: "600px" }}
            >
              <div className="form-input">
                <label htmlFor="name" className="required">
                  Name of Subject Area
                </label>
                <input
                  value={name}
                  className="form-control"
                  onChange={(e) => setName(e.target.value)}
                  type="text"
                  name="name"
                  id="name"
                />
              </div>
              <div className="form-input">
                <label htmlFor="description">Description</label>
                <textarea
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  className="form-control"
                  type="text"
                  name="description"
                  id="description"
                />
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  justifyContent: "end",
                }}
              >
                <Button type="submit" disabled={loading.create}>
                  {loading.create ? (
                    <Spinner size={"sm"} color="white" />
                  ) : (
                    "Create"
                  )}
                </Button>
              </div>
            </form>
          </div>
        ) : (
          <AccessDenied />
        )}
      </div>
    </>
  );
};

export default CreateSubjectArea;
